// extracted by mini-css-extract-plugin
export default {"layout":"TopGames_layout__AyJ63","counter":"TopGames_counter__mluKP"};